/**
 * @desc rsa加密
 * @param obj - 需要加密的对象
 * @returns 加密字符串
 */
/* eslint-disable */
// @ts-ignore
import { JSEncrypt } from 'encryptlong';
/* eslint-enable */
export function rsa(obj: any) {
  const json = JSON.stringify(obj);
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCsScqHUzRDQOWM9pdqE3u3sr2KqBxzmRGy6F36fIXXvGtZKA03QVnuJOXIRjM81DQ302Jy8Xwa5VDY2Dxh6UxGrgjKZ8MXyZzkz6jPk6Cjxg7XHLbXwee2y9esRs/w/leQttlwH1NkZIpd65Ht3VpYkmPYnn+cWKuL+zKK9Ygi2QIDAQAB');
  const rsa: string = encrypt.encryptLong(json);
  return rsa;
}
